import { render } from "./PartialPaymentHeaderLabel.vue?vue&type=template&id=2257fba0&lang=pug"
import script from "./PartialPaymentHeaderLabel.vue?vue&type=script&lang=js"
export * from "./PartialPaymentHeaderLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__